export const commandList = {
  INSTALL_APP: 'install_app',
  UNINSTALL_APP: 'uninstall_app',
  PIN_BOOKMARK: 'add_bookmark',
  UNPIN_BOOKMARK: 'remove_bookmark',
  REQUEST_DEVICE_INFO: 'request_device_info',
  REQUEST_TOKEN: 'request_token',
  SHOW_NOTIFICATION: 'show_notification',
  REQUEST_PAYMENT_PROFILE: 'request_payment_profile',
  REQUEST_INSTALLED_APPS: 'request_installed_apps',
  REQUEST_BOOKMARKS: 'request_bookmarks',
  REQUEST_SETTING: 'request_setting',
  UPDATE_SETTING: 'update_setting',
  MOZAPP_UPDATE: 'mozapp_update',
  BOOKMARK_UPDATE: 'bookmark_update',
  TASK_QUEUE_UPDATE: 'task_queue_update',
  SHOW_TOAST: 'show_toast',
  CANCEL_DOWNLOAD: 'cancel_download',
  LAUNCH_APP: 'launch_app',
  UPDATE_APP: 'update_app',
  REQUEST_PAYMENT: 'request_payment',
  CHECK_APP_UPDATE: 'check_app_update',
  ACCOUNT_EVENT: 'account_event',
  OPEN_ACCOUNT: 'open_account',
  GET_ACCOUNT_VERSION: 'get_account_version',
  CHANGE_THEME_COLOR: 'change_theme_color',
  REQUEST_RELOAD: 'request_reload',
  CHECK_REBOOT: 'check_reboot',
  REQUEST_EXIT: 'request_exit',
  FIRST_VIEW_DID_MOUNT: 'first_view_did_mount'
};



/** WEBPACK FOOTER **
 ** ./~/kaistore-post-messenger/lib/command-list.js
 **/